module.exports = "<div class=\"selectorDiv card viewInfo\">\n  <div class=\"col-lg-12\">\n    <div class=\"table-container\">\n\n    </div>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/User management/user-page/permissions/permissions.component.html
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/User management/user-page/permissions/permissions.component.html
// module chunks = main